<template>
  <div :id="id" ref="lineChart" class="lineChart"></div>
</template>

<script>
export default {
  name: 'lineChart',
  props: {
    id: String
  },
  data () {
    return {
    }
  },
  mounted () {
    // this.drawLine()
  },
  destroyed () {
    console.log('destroyedlineChart')
  },
  methods: {
    init (option) {
      // let that = this
      console.log(option)
      let lineChart = this.$echarts.init(document.getElementById(this.id))
      lineChart.showLoading()
      lineChart.setOption({
        ...option
      }, true)
      lineChart.resize()
      lineChart.hideLoading()
    }
  }
}
</script>

<style lang="scss" scoped>
.lineChart {
  width: 100%;
  height: 100%;
}
</style>
